import { render, staticRenderFns } from "./McToTop.vue?vue&type=template&id=eca182f0&scoped=true&"
import script from "./McToTop.vue?vue&type=script&lang=js&"
export * from "./McToTop.vue?vue&type=script&lang=js&"
import style0 from "./McToTop.vue?vue&type=style&index=0&id=eca182f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eca182f0",
  null
  
)

component.options.__file = "McToTop.vue"
export default component.exports